<template>
  <div class="template-broadside">
    <div
      class="single-article__container"
      :style="singleArticleContainerStyle"
    >
      <div class="single-article__wrapper">
        <div class="single-article">
          <section class="single-article__content">
            <!-- id article указан в JSON+LD -->
            <article
              id="article"
              class="single-article__post-content single-article__content-container"
              @click="checkImageClick"
            >
              <template v-for="(content, idx) in slicedContents">
                <!-- контент статьи-->
                <TheContent
                  v-for="item of content"
                  :key="item.id"
                  :elem="item"
                  :lazy-loading-enabled="true"
                />

                <!-- виджеты внутри контента-->
                <WidgetsRendererContainer
                  v-if="
                    isWidgetsRendererVisible && typeof widgetsInsideContent[idx] !== 'undefined'
                  "
                  :widgets="widgetsInsideContent[idx]"
                />
              </template>
            </article>

            <footer class="article__footer">
              <AdminControlsPanel
                v-if="isAuthenticatedInWordpress"
                class="admin-controls"
                :views-count="viewsCount"
                :edit-link-href="editLinkHref"
                :loading="getLoadingViews(article.id)"
                @click-on-restore-button="updateViewsCount(article.id)"
              />

              <!-- блок автора и экспертов-->
              <div class="single-article__authors">
                <AuthorsExperts
                  :author="article.author"
                  :expert="article.expert"
                />
              </div>

              <!-- текст под контентом статьи. Обложка, источник и тп-->
              <ArticleNote
                class="article-note"
                :class="{ 'article-note_empty': !articleNotes.length }"
                :notes="articleNotes"
              />

              <!-- ArticleCardActions-->
              <component
                :is="articleCardComponent"
                class="article__actions"
                in-page-position="bottom"
                event-position="bottom"
                :article-id="article.id"
                :url="article.teaserUrl || article.url"
                :cover-url="
                  article.img && article.img[0] && article.img[0].url ? article.img[0].url : null
                "
                :comments-enabled="article.commentsEnabled && !article.teaserUrl"
                :comments-count="commentsCount"
                :title="articleTitle"
                :user="user"
                :favorite="favorites"
                :folders="folders"
                :can-have-reactions="article.canHaveReactions"
                @favorite-delete="(favorite) => onFavoriteDelete(favorite, article)"
                @favorite-create-folder-and-add="
                  (nameFolder) => onFavoriteCreateFolderAndAdd(nameFolder, article)
                "
                @favorite-create-folder-and-transfer="
                  (nameFolder, favorite) =>
                    onFavoriteCreateFolderAndTransfer(nameFolder, favorite, article)
                "
                @favorite-transfer-to-folder="
                  (favorite, folder) => onFavoriteTransferToFolder(favorite, folder, article)
                "
                @favorite-add-to-folder="(folder) => onFavoriteAddToFolder(folder, article)"
                @favorite-deferred="onFavoriteDeferred"
              />
            </footer>
          </section>

          <!-- зона виджетов "над комментариями"-->
          <WidgetsRendererContainer
            v-if="isWidgetsRendererVisible || isAdsException"
            class="widgets above-comments-widgets__container"
            :widgets="aboveCommentsWidgets"
          />

          <!-- комментарии-->
          <CommentsContainer
            v-if="showComments"
            :id="article.id"
            class="comments"
          />

          <!-- зона виджетов "под комментариями"-->
          <WidgetsRendererContainer
            v-if="isWidgetsRendererVisible || isAdsException"
            class="below-comments-widgets__container"
            :widgets="belowCommentsWidgets"
          />
        </div>
      </div>

      <!-- Полноэкранная галерея-->
      <FullScreenGallery
        v-if="isGalleryVisible"
        :image-urls="imagesSrc"
        :srcset="imagesSrcset"
        :current-slide="currentImageId"
        @close="closeGallery"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import GeneralTemplates from './general'; // Берем за основу компонент generalTemplate, но даем ему уникальное имя

  // Берем за основу компонент generalTemplate, но даем ему уникальное имя
  // Без уникального имени может рендериться не корректный шаблон
  export default defineNuxtComponent({
    ...GeneralTemplates,
    name: 'BroadSide',
  });
</script>

<style lang="scss" scoped>
  .template-broadside {
    .single-article {
      width: 100%;
      max-width: 640px;
      margin: 0 auto;

      @include tablet {
        background: white;
        padding-bottom: 1px;
        max-width: unset;
      }

      @include big-tablet {
        max-width: 1280px;
      }

      &__authors {
        margin-top: 26px;
        padding: 0 16px;
        @include tablet {
          padding: 0;
        }
        @include big-tablet {
          padding: 0 24px;
        }
      }

      &__content {
        background: white;
        margin-bottom: 24px;
      }

      &__wrapper {
        max-width: 1280px;

        @include tablet {
          background: white;
          border: 1px solid #e7e7e7;
          border-top: none;
        }

        @include desktop {
          margin: 0 auto;
        }
      }

      // Remove margin for first core-html which is quiz or test
      .core-html:first-of-type {
        margin: 0;
      }
    }

    .article-note {
      margin-top: 0;
    }

    .single-article__content-container {
      max-width: 640px;
      margin-bottom: 24px;

      @include tablet {
        margin-bottom: 0;
      }
    }

    .single-article__post-content {
      background: white;
      margin-left: auto;
      margin-right: auto;
      overflow: initial;
      @include big-tablet {
        max-width: 732px;
        padding: 0;
      }
    }

    .article__footer {
      max-width: 592px;
      margin-left: auto;
      margin-right: auto;
      display: inherit;
      background: white;
      @include big-tablet {
        padding: 0;
        margin: 0 auto;
        max-width: 780px;
      }
    }

    .widgets-renderer {
      margin-left: auto;
      margin-right: auto;
      min-width: unset;
      display: block;
      @include big-tablet {
        max-width: 780px;
        margin: 0 auto;
      }
    }

    .admin-controls {
      margin-left: 16px;
      margin-bottom: 16px;

      @include tablet {
        margin-left: 24px;
      }
    }

    .age-calculator {
      @include tablet {
        margin: 0 0 12px;
      }
    }

    .ovulation-calculator {
      @include big-tablet {
        margin: 0 0 12px;
      }
    }
  }
</style>
